/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../utils';
// prettier-ignore
const ArrowBottomIcon = createIcon({
    displayName: 'ArrowBottomIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "m18.5 14.015-.987-.897a86.398 86.398 0 0 1-4.845 4.913V4h-1.335v14.03a86.703 86.703 0 0 1-3.196-3.148 90.716 90.716 0 0 1-1.65-1.764l-.987.897a90.234 90.234 0 0 0 1.674 1.79 87.913 87.913 0 0 0 3.923 3.84 1.332 1.332 0 0 0 1.807 0 88.156 88.156 0 0 0 5.596-5.63Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M13.354 22.475c-.38.35-.867.525-1.354.525-.487 0-.975-.175-1.354-.524A134.332 134.332 0 0 1 2.26 14.03l1.481-1.345c.819.9 1.645 1.783 2.472 2.646A129.577 129.577 0 0 0 11 20.055V1h2v19.054a129.875 129.875 0 0 0 4.788-4.722c.828-.864 1.653-1.747 2.472-2.647l1.48 1.345a146.41 146.41 0 0 1-2.509 2.686 131.804 131.804 0 0 1-5.877 5.76Z"
        })
    ]
});
ArrowBottomIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'ArrowBottomIcon'
};
export { ArrowBottomIcon };

//# sourceMappingURL=arrow-bottom.js.map